import { render, staticRenderFns } from "./EventBase.vue?vue&type=template&id=53d99762"
import script from "./EventBase.vue?vue&type=script&lang=js"
export * from "./EventBase.vue?vue&type=script&lang=js"
import style0 from "./EventBase.vue?vue&type=style&index=0&id=53d99762&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports